jQuery(document).ready(function ($) {

  //Nav Functionality - Start
  $('.nav-primary .nav-toggle').click(function () {
    // $('.nav-primary .ul1').slideToggle('slow');
    // $('.nav-toggle .fa-bars').toggle();
    // $('.nav-toggle .fa-times').toggle();
    // $('header').toggleClass('fixed');
    // $('body').toggleClass('fixed');
    if ($('.nav-primary .ul1').is(':visible')) {
      $('.nav-toggle .fa-bars').show();
      $('.nav-toggle .fa-times').hide();
      $('.nav-primary .ul1').slideUp('slow');
    } else {
      $('.nav-toggle .fa-bars').hide();
      $('.nav-toggle .fa-times').show();
      $('.nav-primary .ul1').slideDown('slow');
    }
  });

  $('.nav-primary .nav-toggle').on('keypress', function (e) {
    if (e.which === 13) {
      // $('.nav-primary .ul1').slideToggle('slow');
      // $('.nav-toggle .fa-bars').toggle();
      // $('.nav-toggle .fa-times').toggle();
      // $('header').toggleClass('fixed');
      // $('body').toggleClass('fixed');
      if ($('.nav-primary .ul1').is(':visible')) {
        $('.nav-toggle .fa-bars').show();
        $('.nav-toggle .fa-times').hide();
        $('.nav-primary .ul1').slideUp('slow');
      } else {
        $('.nav-toggle .fa-bars').hide();
        $('.nav-toggle .fa-times').show();
        $('.nav-primary .ul1').slideDown('slow');
      }
    }
  });

  // primary nav
  $('.nav-primary').accessibleNav({
    desktop: 990,
    spans: 'hide',
    level2position: 'vertical-bottom',
    level3position: 'vertical-bottom'
  });
  //Nav Functionality - End

  //Search Functionality - Start
  $('.search-toggle').click(function () {
    $('body').addClass('search-open');
    $('.search-box').slideDown('slow');
    $('.search-box input').first().focus();
    $('.search-box .fa-times').click(function () {
      $('.search-box').slideUp('slow');
      $('body').removeClass('search-open');
    });
    // find focusable items
    var searchFocusable = $('.search-box span.fas.fa-times, .search-box .search-container a.btn-search, .search-box .search-container input');
    var searchFocusableFirst = searchFocusable.first();
    var searchFocusableLast = searchFocusable.last();
    searchFocusableLast.on('keydown', function (e) {
      if ((e.which === 9 && !e.shiftKey)) {
        e.preventDefault();
        searchFocusableFirst.focus();
      }
    });
    searchFocusableFirst.on('keydown', function (e) {
      if ((e.which === 9 && e.shiftKey)) {
        e.preventDefault();
        searchFocusableLast.focus();
      }
    });
  });

  $('.search-toggle').on('keypress', function (e) {
    if (e.which === 13) {
      $('.search-box').slideDown('slow');
      $('.search-box input').first().focus();
      $('.search-box .fa-times').on('keypress', function (e) {
        if (e.which === 13) {
          $('.search-box').slideUp('slow');
        }
      });
      // find focusable items
      var searchFocusable = $('.search-box span.fas.fa-times, .search-box .search-container a.btn-search, .search-box .search-container input');
      var searchFocusableFirst = searchFocusable.first();
      var searchFocusableLast = searchFocusable.last();
      searchFocusableLast.on('keydown', function (e) {
        if ((e.which === 9 && !e.shiftKey)) {
          e.preventDefault();
          searchFocusableFirst.focus();
        }
      });
      searchFocusableFirst.on('keydown', function (e) {
        if ((e.which === 9 && e.shiftKey)) {
          e.preventDefault();
          searchFocusableLast.focus();
        }
      });
    }
  });
  //Search Functionality - End

  //Scroll to Top
  $(window).scroll(function () {
    if ($(this).scrollTop() > 250) {
      $(".scroll-to-top").css("opacity", "1");
    } else {
      $(".scroll-to-top").css("opacity", "0");
    }
  });
  $(".scroll-to-top").click(function () {
    $('html, body').animate({
      scrollTop: 0
    }, 1000);
    return false;
  });

  // Stats
  $(function ($, win) {
    $.fn.inViewport = function (cb) {
      return this.each(function (i, el) {
        function visPx() {
          var H = $(this).height(),
            r = el.getBoundingClientRect(), t = r.top, b = r.bottom;
          return cb.call(el, Math.max(0, t > 0 ? H - t : (b < H ? b : H)));
        } visPx();
        $(win).on("resize scroll", visPx);
      });
    };
  }(jQuery, window));
  $('.stat').inViewport(function (px) {
    if (px > 0 && !this.initNumAnim) {
      this.initNumAnim = true;
      $(this).prop('Counter', 0).animate(
        {
          Counter: $(this).text()
        },
        {
          duration: 4000,
          easing: 'linear',
          step: function (now, tween) {
            if (parseInt(tween.end) == parseFloat(tween.end)) {
              $(this).text(Math.ceil(now));
            } else {
              $(this).text(now.toFixed(1));
            }
          },
        });
    }
  });

  // $(window).scroll(function () {
  //   $(".scroll-to-top").removeClass("move");
  //   if ($(window).scrollTop() + $(window).height() > ($(document).height() - 100)) {
  //     $(".scroll-to-top").addClass("move");
  //   }
  // });
  //Scroll to Top END

  //Highlighted Box icon - hide image if nothing uploaded
  $(".highlighted-boxes .box .icon img[src$='{{box-icon}}']").css('display', 'none');

});

//Article Columns
$.articleColumns();